import React, { useState, useRef, useEffect } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Task } from '../../types/workOrders';

interface TaskDescriptionProps {
  task: Task;
}

export function TaskDescription({ task }: TaskDescriptionProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsTruncation, setNeedsTruncation] = useState(false);
  const descRef = useRef<HTMLDivElement>(null);
  const addRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const checkTruncation = () => {
      const descElement = descRef.current;
      const addElement = addRef.current;

      const isDescTruncated = descElement && descElement.scrollHeight > descElement.clientHeight;
      const isAddTruncated = addElement && addElement.scrollHeight > addElement.clientHeight;

      setNeedsTruncation(isDescTruncated || isAddTruncated);
    };

    checkTruncation();
    window.addEventListener('resize', checkTruncation);
    return () => window.removeEventListener('resize', checkTruncation);
  }, [task.desc, task.add]);

  return (
    <>
      <div
        ref={descRef}
        className={`text-gray-900 dark:text-gray-100 ${!isExpanded && 'line-clamp-2'}`}
      >
        {task.desc}
      </div>

      {task.add && (
        <p
          ref={addRef}
          className={`text-sm text-gray-600 dark:text-gray-400 mt-3 ${!isExpanded && 'line-clamp-2'}`}
        >
          {task.add}
        </p>
      )}

      {needsTruncation && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-sm text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 mt-2 flex items-center gap-1"
        >
          {isExpanded ? (
            <>
              <ChevronUp className="h-4 w-4" />
              Show Less
            </>
          ) : (
            <>
              <ChevronDown className="h-4 w-4" />
              Show More
            </>
          )}
        </button>
      )}

      {task.qty > 0 && (
        <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
          Quantity: {task.qty}
        </p>
      )}
    </>
  );
}